// @ts-ignore
import { getUserData } from "@/auth/getUserData";
// @ts-ignore
import { resolveVariables } from "@/utils/variables";
// @ts-ignore
import i18n from "@/libs/i18n";
// @ts-ignore
import { formatDate } from "@/utils/luxon";
import ActiveChatLogInterface from "@/interfaces/inbox/activeChatLog.interface";
import ChannelInterface from "@/interfaces/channel.interface";
import { FormattedActiveChatInterface } from "@/interfaces/inbox/formattedActiveChat.interface";
// @ts-ignore
import { getInstance } from "@/auth/auth0";
import { PublicApiEndpointPathType } from "@/composables/v2.1/useInboxModuleType";
import { DateTime } from "luxon";
import useStoredMessages from "@/composables/v2.1/useStoredMessages";

/**
 * @TODO These are more-or-less utils, so "activeChat" naming is a bit confusing. Needs to be moved/renamed.
 */

export default function useEmailActiveChat() {
    const resolveSenderName = (channel: ChannelInterface) => {
        // Get the name from channel settings
        if (channel.id) {
            const channelSettingSenderName = channel.settings?.find(
                // @ts-ignore
                (setting) => setting.name === "email_sender"
            );

            if (channelSettingSenderName && channelSettingSenderName.value.length > 0) {
                return resolveVariables(channelSettingSenderName.value);
            }
            return channel.name ?? "";
        }

        // Fallback if no active channel can be found (which will be unexpected btw).
        return getUserData().displayName;
    };

    const resolveSignature = (channel: ChannelInterface) => {
        const emailSignatureSetting = channel.settings?.find((setting) => setting.name === "email_signature");

        if (emailSignatureSetting) {
            return `<br><br>${resolveVariables(emailSignatureSetting.value)}`;
        }

        return "";
    };

    const resolveReplyMessage = (activeChat: FormattedActiveChatInterface) => {
        // Active chat in the constructor is not reactive here, because this file is instantiated only once.
        // Should be fixed some day, because this was lack of knowledge. For now solved it by passing the it as argument.

        const { emailStoredMessages } = useStoredMessages();
        const storedMessage = emailStoredMessages.value?.find((item) => item.chatId === activeChat.lastConversation.id);
        const lastMessageEntries =
            activeChat.chatLog[activeChat.chatLog.length - 1].entries[
                activeChat.chatLog[activeChat.chatLog.length - 1].entries.length - 1
            ].message;
        const storedMessageNoTags = storedMessage?.message.replace(/(<([^>]+)>)/gi, "");
        if (storedMessage?.message && storedMessage?.message !== lastMessageEntries && !!storedMessageNoTags.length) {
            return storedMessage.message;
        }

        let message = resolveSignature(activeChat.channel);
        message += '<br/><span class="saysimple-previous-correspondence"><br/><br/></span><br/>';

        activeChat.chatLog.forEach((conversation: ActiveChatLogInterface) => {
            const entriesSorted = conversation.entries.sort((entryA, entryB) => {
                // @ts-ignore
                return DateTime.fromISO(entryB.time) - DateTime.fromISO(entryA.time);
            });
            let entriesIterator = 0;
            entriesSorted
                // @ts-ignore
                .filter((entry) => ["text", "asset"].includes(entry.type))
                // @ts-ignore
                .forEach((entry) => {
                    // @ts-ignore
                    const fromName = entry?.metadata?.find((metadata) => metadata.name === "from")?.value;
                    if (entriesIterator === 0) {
                        message += addMessageToMessagesStack(entry, fromName);
                    } else if (!entriesSorted[entriesIterator - 1].message.includes(entry.message)) {
                        message += addMessageToMessagesStack(entry, fromName);
                    }
                    message += "<br />";
                    entriesIterator++;
                });
        });
        return message;
    };

    const addMessageToMessagesStack = (entry, fromName) => {
        let txtMessage = `<strong>${i18n.t("entities.email.contact-wrote-at", {
            contactName: fromName ? JSON.parse(fromName).name : "?",
            date: formatDate(entry.time, {
                month: "numeric",
                day: "numeric",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            }),
        })}</strong><br/>`;
        txtMessage += entry.message ?? entry.caption;
        return txtMessage;
    };

    // @ts-ignore
    const setIframeProperties = async (iframe, messageId) => {
        if (!iframe.value) {
            return;
        }

        //this.$store.dispatch("auth/getAccessToken")
        //.then(token => {
        // Get domain and remove customer from it
        const domain = window.location.hostname.startsWith("www")
            ? window.location.hostname.replace(/^www\.[^\.]*/, "")
            : window.location.hostname.replace(/^[^\.]*/, "");

        // Set jwt cookie
        const accessToken = (await getInstance().auth0Client.getTokenSilently({ detailedResponse: true }))?.id_token;
        if (getInstance().auth0Client && accessToken) {
            document.cookie = `jwt=${accessToken};domain=${domain};samesite=lax;path=/`;
        }

        // Only load in iframe after cookies have been set so we don't flood the gateway with expired token errors

        iframe.value.src = `${process.env.VUE_APP_API_GATEWAY?.replace("v1", "v2")}/${
            PublicApiEndpointPathType.EMAIL
        }/messages/${messageId}/content-as-html`;
    };

    return {
        resolveSenderName,
        resolveSignature,
        resolveReplyMessage,
        setIframeProperties,
    };
}
